import React from "react";
import { useTheme } from "next-themes";
import { useLang } from "@/i18n";
import { Lu } from "@/components/shared";

/* Madarek "M" monogram — blue tile with white mark (constant in both themes). */
export function LogoMark({ size = 36, className = "" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 100 100" className={className} data-testid="brand-logo-mark">
      <defs>
        <linearGradient id="mdTile" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#1E5EFF" /><stop offset="100%" stopColor="#0047FF" />
        </linearGradient>
      </defs>
      <rect width="100" height="100" rx="24" fill="url(#mdTile)" />
      <path d="M26 70 V34 L50 58 L74 34 V70" fill="none" stroke="#fff" strokeWidth="11" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M38 70 L74 34" fill="none" stroke="#fff" strokeWidth="11" strokeLinecap="round" strokeOpacity="0.92" />
    </svg>
  );
}

export function BrandWordmark({ size = 36, tagClass = "text-[10px]", nameClass = "" }) {
  const { t } = useLang();
  return (
    <div className="flex items-center gap-3" data-testid="brand-wordmark">
      <LogoMark size={size} />
      <div>
        <p className={`font-extrabold text-foreground leading-none tracking-[0.18em] ${nameClass}`}>MADAREK</p>
        <p className={`${tagClass} font-semibold tracking-[0.3em] mt-1 md-teal-text`}>SMART</p>
      </div>
    </div>
  );
}

export function ThemeToggle({ className = "" }) {
  const { resolvedTheme, setTheme } = useTheme();
  const { lang } = useLang();
  const dark = resolvedTheme === "dark";
  return (
    <button data-testid="theme-toggle-btn" onClick={() => setTheme(dark ? "light" : "dark")}
      aria-label={lang === "ar" ? "تبديل الوضع" : "Toggle theme"} title={lang === "ar" ? (dark ? "الوضع الفاتح" : "الوضع الداكن") : (dark ? "Light mode" : "Dark mode")}
      className={`relative w-10 h-10 rounded-lg bg-foreground/5 hover:bg-foreground/10 border border-border flex items-center justify-center text-foreground/80 ${className}`}>
      <Lu name="sun" className={`w-4.5 h-4.5 absolute transition-all duration-300 ${dark ? "opacity-0 rotate-90 scale-50" : "opacity-100 rotate-0 scale-100"}`} style={{ width: 18, height: 18 }} />
      <Lu name="moon" className={`w-4.5 h-4.5 absolute transition-all duration-300 ${dark ? "opacity-100 rotate-0 scale-100" : "opacity-0 -rotate-90 scale-50"}`} style={{ width: 18, height: 18 }} />
    </button>
  );
}
